import { Navigate, Route, Routes } from 'react-router-dom';

import { ProtectedRoute } from '@/auth/ProtectedRoute';
import { AppLayout } from '@/components/layout/AppLayout';
import { PeriodProvider } from '@/state/PeriodContext';
import { CuratePage } from '@/pages/curate/CuratePage';
import { DashboardPage } from '@/pages/dashboard/DashboardPage';
import { ComplaintDetailPage } from '@/pages/lens/ComplaintDetailPage';
import { LensPage } from '@/pages/lens/LensPage';
import { LoginPage } from '@/pages/login/LoginPage';
import { ROUTES } from '@/routes/paths';

export function App() {
  return (
    <Routes>
      <Route path={ROUTES.login} element={<LoginPage />} />

      <Route
        element={
          <ProtectedRoute>
            <PeriodProvider>
              <AppLayout />
            </PeriodProvider>
          </ProtectedRoute>
        }
      >
        <Route path={ROUTES.dashboard} element={<DashboardPage />} />

        {/* Lens: default lands on RSQ; :domain selects which set of bars
            renders; :complaint opens the indicator drilldown. */}
        <Route path={ROUTES.lens} element={<Navigate to="/lens/rsq" replace />} />
        <Route path={ROUTES.lensDomain} element={<LensPage />} />
        <Route path={ROUTES.lensComplaint} element={<ComplaintDetailPage />} />

        <Route path={ROUTES.curate} element={<CuratePage />} />
      </Route>

      <Route path={ROUTES.root} element={<Navigate to={ROUTES.dashboard} replace />} />
      <Route path="*" element={<Navigate to={ROUTES.dashboard} replace />} />
    </Routes>
  );
}
